module.exports = __webpack_public_path__ + "static/img/system4.a6fc120.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/system/system4.png
// module id = w4s3
// module chunks = 0